module.exports = __webpack_public_path__ + "img/platform.044e7cb1.png";